import { MutationTree } from 'vuex';
import { EMoveResourceMutation } from './move-resource.constants';
import { IMoveResourceState } from './move-resource.types';
import { IResource } from '@/api/resources/types/resource';

export const mutations: MutationTree<IMoveResourceState> = {
  [EMoveResourceMutation.SetLoading](state: IMoveResourceState, loading: boolean) {
    state.loading = loading;
  },
  [EMoveResourceMutation.SetLoaded](state: IMoveResourceState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EMoveResourceMutation.SetResource](state: IMoveResourceState, resource: IResource) {
    state.resource = resource;
  },
  [EMoveResourceMutation.SetMoving](state: IMoveResourceState, moving: boolean) {
    state.moving = moving;
  },
  [EMoveResourceMutation.SetMovedResource](state: IMoveResourceState, movedResource: IResource) {
    state.movedResource = movedResource;
  },
  [EMoveResourceMutation.SetState](state: IMoveResourceState, newState: IMoveResourceState) {
    state.loading = newState.loading;
    state.loaded = newState.loaded;
    state.resource = newState.resource;
    state.movedResource = newState.movedResource;
    state.moving = newState.moving;
  },
};
